// Simple audit log data module
const dataLog = {
    saveLogItem(logItem) {
        // For now, just log to console
        // In a real implementation, this would save to a database or send to an API
        console.log('Audit Log:', {
            timestamp: new Date().toISOString(),
            ...logItem
        });
    }
};

export { dataLog }; 